import service from '../services/app'
import {delay, model} from './common'
import {routerRedux} from 'dva/router'
import modelExtend from 'dva-model-extend'

let countDownState = false

const LOGIN_TO = {
  ticket: '/ticket',
  groupApply: '/group-apply/list',
}

export default modelExtend(model, {
  namespace: 'login',

  state: {
    errorMessage: undefined,
    countDown: 0,
    loginTo: undefined,
  },
  subscriptions: {
    setupHistory({dispatch, history}) {
      history.listen((location) => {
        if (location.pathname === '/login') {
          dispatch({
            type: 'init',
          })
        } else {
          countDownState = false
        }
      })
    },
  },

  effects: {
    * init({payload,}, {call, put, select}) {
      countDownState = false
      yield put({
        type: 'updateState',
        payload: {
          countDown: 0,
        }
      })
    },
    * sendVerifyCode({payload}, {call, put, select}) {

      yield call(service.sendVerifyCode, payload)

      // 60秒倒计时...
      let countDown = 60
      countDownState = true
      while (countDown > 0) {
        if (countDownState === false) {
          return
        }
        countDown--
        yield put({
          type: 'updateState',
          payload: {
            countDown
          }
        })
        yield call(delay, 1000);
      }
    },
    * login({payload}, {put, call, select}) {
      yield put({
        type: 'updateState',
        payload: {errorMessage: undefined},
      })
      const {success, message} = yield call(service.login, payload)
      if (success) {
        yield put({type: 'app/query'})
        const {loginTo} = yield select(_ => _.app)
        yield put(routerRedux.replace(LOGIN_TO[loginTo || 'ticket']))
      } else {
        yield put({
          type: 'updateState',
          payload: {
            errorMessage: message,
          },
        })
      }
    },
  },
})
